// extracted by mini-css-extract-plugin
export default {"name":"Krpje_TPAJFh7XvrThx8","deleteButton":"dhA7ym3PrsUAsl7Up0kl"};